<script setup lang="ts" generic="T">

import { ref } from 'vue';

import { computed } from '#imports';

const isOpen = ref(false);

const props = defineProps<{
    values: OptionValue<T>[];
    selectedValue: T;
    label: string;
}>();
const emit = defineEmits<{
    (e: 'onChange', payload: T): void;
}>();

const computedSelectedValue = computed(() => props.values.find(item => item.value === props.selectedValue) || props.values[0]);

</script>

<template>
  <Dropdown :is-open="isOpen"
            @update:is-open="(value: boolean) => isOpen = value"
  >
    <template #toggle>
      <button class="compact-500-accent sorts-btns display-flex align-items-center justify-center gap-8 filter-by cursor-pointer"
              type="button"
              @click="isOpen = !isOpen"
      >
        <IconMain :size="24"
                  icon="sort"
        />
        <span class="display-none display-block-bp-576 compact-500-accent">{{ label }}</span>
        <span class="display-none-bp-576 text-wrap-none compact-500-accent">
          {{ computedSelectedValue?.label }}
        </span>

        <IconMain :size="24"
                  :class="{ 'rotate-180': isOpen }"
                  icon="chevron-down"
        />
      </button>
    </template>
    <template #content>
      <div class="sort-block display-flex flex-column align-items-start gap-20 width-full">
        <div v-for="({ label: labelValue, value }, index) in values"
             :key="index"
             class="width-full display-flex align-items-center justify-between"
        >
          <button type="button"
                  class="display-flex align-items-center sort-value gap-12 cursor-pointer"
                  @click="emit('onChange', value)"
          >
            <span class="compact-500-accent text-wrap-none">
              {{ labelValue }}
            </span>

            <IconMain v-if="selectedValue === value"
                      :size="16"
                      icon="check-mark"
            />
          </button>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<style scoped lang="scss">
.sort-block {
  min-width: var(--control-500-size-single, 52px);
  padding: 20px 10px;
  border-radius: var(--control-500-radius, 2px);
  background: var(--bg-secondary);
}

.sort-value {
  transition: opacity 0.3s ease-in-out;
  background: transparent;
  color: var(--content-primary);

  &:hover {
    opacity: 0.4;
  }
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.2s ease-in-out;
}
</style>
